import React, { useEffect, useState } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import { Checkbox } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import type { DeactivateAntennasData } from "../../../api";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type DeactivateAntennasNode = Node<InterfaceToRecord<DeactivateAntennasData & ExtraNodeData>>;

export default function DeactivateAntennas(props: NodeProps<DeactivateAntennasNode>): JSX.Element {
    const { t } = useTranslation();
    const [antennaA, setAntennaA] = useState(props.data.antennaA ?? true);
    const [antennaBVehicle, setAntennaBVehicle] = useState(props.data.antennaBVehicle ?? true);
    const [antennaBStationary, setAntennaBStationary] = useState(
        props.data.antennaBStationary ?? true,
    );

    const updateNode = useUpdateNodeData<DeactivateAntennasNode>(props.id);

    useEffect(() => {
        updateNode({ antennaA, antennaBVehicle, antennaBStationary });
    }, [antennaA, antennaBVehicle, antennaBStationary, updateNode]);

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <Checkbox
                label={t("component.actionConfigNodes.deactivate_antenna.0")}
                checked={antennaA}
                onChange={(_e, checked) => setAntennaA(checked!)}
            />
            <Checkbox
                label={t("component.actionConfigNodes.deactivate_antenna.1")}
                checked={antennaBVehicle}
                onChange={(_e, checked) => setAntennaBVehicle(checked!)}
            />
            <Checkbox
                label={t("component.actionConfigNodes.deactivate_antenna.2")}
                checked={antennaBStationary}
                onChange={(_e, checked) => setAntennaBStationary(checked!)}
            />
        </ActionConfigNode>
    );
}
